import React from 'react'
import { ImportantFootnote } from '../../common/ImportantFootnote'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { ProfessionalDetailsItem } from './ProfessionalDetailsItem'

interface ProfessionalDetailsProps {
  profile: MemberProfileExtendedType
}

export const ProfessionalDetails = ({ profile }: ProfessionalDetailsProps) => {
  const { professional_details } = profile

  return (
    <div className='flex flex-col gap-2 p-10'>
      {Object.entries(professional_details).map(([key, value]) => (
        <ProfessionalDetailsItem key={key} keyName={key} value={value} />
      ))}
      <ImportantFootnote
        className='mt-8 text-[10px]'
        text='This information is supplied by the Bar Standards Board.'
      />
    </div>
  )
}
